import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pick from 'lodash/pick';
import withProducts from './withProducts';
import withProductKey from './withProductKey';
import { skus } from 'src/common/config/product';
import { findProductById } from 'src/common/utils/product';
import { updateProductCustomisation, removeProductCustomisation } from 'src/client/js/store/actions/product';
import { getProductCustomisation } from 'src/client/js/store/selectors/product';

const withProductCustomisation = compose(
  withProducts,
  withProductKey,
  connect(
    (state) => ({
      productCustomisation: getProductCustomisation(state),
    }),
    (dispatch, props) => ({
      updateProductCustomisation: customisation => {
        const product = findProductById(props.products, skus[props.productKey]);
        const picked = pick(customisation, [...product.customisations, 'locale']);
        return dispatch(updateProductCustomisation(props.productKey, picked));
      },
      removeProductCustomisation: keys => dispatch(removeProductCustomisation(keys))
    }),
  ),
);

export default withProductCustomisation;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withProductCustomisation.js